import { render, staticRenderFns } from "./curriculum-details.vue?vue&type=template&id=7233d50c&scoped=true"
import script from "./curriculum-details.vue?vue&type=script&lang=js"
export * from "./curriculum-details.vue?vue&type=script&lang=js"
import style0 from "./curriculum-details.vue?vue&type=style&index=0&id=7233d50c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7233d50c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7233d50c')) {
      api.createRecord('7233d50c', component.options)
    } else {
      api.reload('7233d50c', component.options)
    }
    module.hot.accept("./curriculum-details.vue?vue&type=template&id=7233d50c&scoped=true", function () {
      api.rerender('7233d50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/curriculum-details.vue"
export default component.exports